import React from 'react'
import { Icon, Modal, Button, Accordion, List } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';

import { Form } from 'formsy-semantic-ui-react';

import 'react-quill/dist/quill.snow.css'; // ES6
import TextEditor from '../../../../common/TextEditor';


var moment = require('moment');
class OnHoldModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onholdComments: '',
            // editOnHoldComments: props.currentNote ? props.currentNote.comment : '',
            activeIndex: 0
        }

    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })

    }

    close = () => {
        if (this.props.clickStatus === "addOnHoldComment") {
            this.setState({
                onholdComments: '',
            })
        }
        else if (this.props.clickStatus === "editOnHoldComment") {
            this.setState({
                onholdComments: this.state.onholdComments,
            })
        }
        this.props.OnHoldModalClose(false, this.props.clickStatus);
    }

    addOnHoldComments = () => {

        if (this.props.clickStatus === "addOnHoldComment") {
            let commentObj = {
                comment: this.state.onholdComments,
                accountUserId: this.props.user._id,
                onHoldDate: moment(),
                isImplicitOnHold: true
            }
            let onHoldDependActivtyComment = {
                comment: `Activity put on hold because dependent activity ${this.props.selectedActivityData.name} put on hold.`,
                accountUserId: this.props.user._id,
                onHoldDate: moment()
            }
            if (!this.props.selectedActivityData.onHoldComments) {
                this.props.selectedActivityData.onHoldComments = []
            }
            this.props.selectedActivityData.onHoldComments.unshift(commentObj);
            this.props.selectedActivityData.onHoldFlag = true;
            this.props.selectedActivityData.string = "PutOnHold";
            this.props.selectedActivityData.onHoldDependActivtyComment = onHoldDependActivtyComment;
            if (this.props.activeTab === "myactivities") {
                dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
            }
            else {
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
            }

            this.close();
        }

        else if (this.props.clickStatus === "editOnHoldComment") {
            let index = this.props.selectedActivityData.onHoldComments.findIndex(x => x._id === this.props.currentNote._id);
            let commentObj = {
                _id: this.props.currentNote._id,
                comment: this.state.onholdComments ? this.state.onholdComments : this.props.currentNote.comment,
                accountUserId: this.props.currentNote.accountUserId,
                onHoldDate: moment(),
                isImplicitOnHold: this.props.currentNote.isImplicitOnHold
            }
            this.props.selectedActivityData.onHoldComments[index] = commentObj;

            if (this.props.activeTab === "myactivities") {
                dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
            }
            else {
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
            }
            this.close();
        }

    }
    getMapping(id) {
        if (this.props.activityOptions) {
            for (let i = 0; i < this.props.activityOptions.length; i++) {
                let activity = this.props.activityOptions[i];
                if (id === activity._id) {
                    return activity.name;
                }
                if (activity.activities) {
                    for (let j = 0; j < activity.activities.length; j++) {
                        let subActivity = activity.activities[j];
                        if (id === subActivity._id) {
                            return <span>{activity.name} <Icon name="chevron right" /> {subActivity.name} </span>;
                        }
                        if (subActivity.activities) {
                            for (let k = 0; k < subActivity.activities.length; k++) {
                                let childActivity = subActivity.activities[k];
                                if (id === childActivity._id) {
                                    return <span > {activity.name} <Icon name="chevron right" />  {subActivity.name} <Icon name="chevron right" /> {childActivity.name}</span>;
                                }
                            }
                        }
                    }
                }
            }
        }
    }


    updateText = (data, name) => {
        if (name === "Comment") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ onholdComments: '' })
            } else {
                this.setState({ onholdComments: data })
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.currentNote.comment !== nextProps.currentNote.comment) {
            this.setState({ onholdComments: nextProps.currentNote.comment })
        }
        if (nextProps.clickStatus === "addOnHoldComment") {
            this.setState({ onholdComments: '' })
        }
        else if (nextProps.clickStatus === "editOnHoldComment") {
            this.setState({ onholdComments: nextProps.currentNote.comment })
        }
    }

    render() {
        const { activeIndex } = this.state
        return (
            <Modal
                className="NotesModalCard basicModal"
                open={this.props.onHoldFlag}
                size='tiny'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>{this.props.clickStatus === "editOnHoldComment" ? <span className="clr-blue" >Edit Put On Hold</span> :
                    <span className="clr-blue" >Put On Hold</span>}
                </Modal.Header>
                <Modal.Content scrolling>
                    <span className="head">{this.props.selectedActivityData.name}</span>
                    {this.props.selectedActivityData.dependentNodes && this.props.selectedActivityData.dependentNodes.length ?

                        <Accordion className="onHoldModal">
                            <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                                <Icon name='dropdown' />
                                There are {this.props.selectedActivityData.dependentNodes && this.props.selectedActivityData.dependentNodes.length} dependent activities which will be put on hold.
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 0}>
                                <List divider>
                                    {this.props.selectedActivityData.dependentNodes && this.props.selectedActivityData.dependentNodes.map((dependency) => {
                                        return (<List.Item key={dependency}>
                                            <List.Content className="list_content" verticalAlign='middle'>{this.getMapping(dependency)}</List.Content>
                                        </List.Item>)

                                    })}
                                </List>
                            </Accordion.Content>
                        </Accordion>

                        : ''}
                    <br />

                    <Form noValidate
                        ref={ref => this.form = ref}
                        className="formcyForm"
                        name="issue"
                        id="issueid"
                        onValidSubmit={() => { this.addOnHoldComments() }}
                    >
                        <TextEditor
                            name="Comment"
                            text={this.state.onholdComments}
                            type="textarea"
                            onChangeText={this.updateText}
                            requiredValue={true}
                            autoFocus={true}
                        />
                        <br />
                        <div className="pull-right" style={{ "marginBottom": "25px" }}>
                            <Button content='Cancel' className="button-cancel" onClick={this.close} />
                            {this.props.clickStatus === "editOnHoldComment" ?
                                <Button type="submit" content='Update' disabled={!this.state.onholdComments || (this.state.onholdComments && this.state.onholdComments.length === 0)} className="button-submit" /> :
                                <Button type="submit" content='Put On Hold' disabled={!this.state.onholdComments || (this.state.onholdComments && this.state.onholdComments.length === 0)} className="button-submit" />}

                        </div>
                        <br />
                    </Form >
                </Modal.Content>

            </Modal>


        )
    }
}



export default OnHoldModal;